import React, { useState } from 'react'
import {
  Search,
  CalendarCheck,
  People,
  ShieldLock,
  Bell,
  Gear,
  CreditCard,
  Megaphone,
  BarChart,
 
} from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'

export default function Features() {
  const [useType, setUseType] = useState('general')
  const navi = useNavigate()

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Membotic Features</h1>

      <div className="d-flex justify-content-center mb-5 gap-2">
        <button
          className={`btn ${useType === 'general' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setUseType('general')}
        >
          General Use
        </button>
        <button
          className={`btn ${useType === 'business' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setUseType('business')}
        >
          Business Use
        </button>
      </div>

      {useType === 'general' && (
        <div className="row">
          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <Search size={28} className="text-primary me-3" />
                  <h5 className="mb-0">Find and Join Clubs</h5>
                </div>
                <p className="text-muted">
                  Browse and search for membership clubs in your area. View details, photos, and contact club owners directly.
                </p>
                <button onClick={() => navi("/searchclubs")} className="btn btn-outline-secondary btn-sm">Search clubs</button>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <CalendarCheck size={28} className="text-primary me-3" />
                  <h5 className="mb-0">Book Classes Easily</h5>
                </div>
                <p className="text-muted">
                  Join pay-as-you-go or subscription-based classes. View schedules and secure your spot in just a few clicks.
                </p>
                <button onClick={() => navi("/timetable")} className="btn btn-outline-secondary btn-sm">Find out more</button>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <People size={28} className="text-primary me-3" />
                  <h5 className="mb-0">Manage Multiple Profiles</h5>
                </div>
                <p className="text-muted">
                  Book for friends or family with separate profiles under your account. Perfect for parents managing children’s activities.
                </p>
                {/* <button className="btn btn-outline-secondary btn-sm">Find out more</button> */}
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <ShieldLock size={28} className="text-primary me-3" />
                  <h5 className="mb-0">Secure Payments</h5>
                </div>
                <p className="text-muted">
                  All transactions are handled securely. Clubs can manage payments, and you get transparency for each booking.
                </p>
                {/* <button className="btn btn-outline-secondary btn-sm">Find out more</button> */}
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <Bell size={28} className="text-primary me-3" />
                  <h5 className="mb-0">Notifications and Messaging</h5>
                </div>
                <p className="text-muted">
                  Get notified about bookings, class changes, or promotions. Message club owners directly from the platform.
                </p>
                {/* <button className="btn btn-outline-secondary btn-sm">Find out more</button> */}
              </div>
            </div>
          </div>
        </div>
      )}

{useType === 'business' && (
  <div className="row">

    <div className="col-md-6 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <CalendarCheck size={28} className="text-primary me-3" />
            <h5 className="mb-0">Class Scheduling</h5>
          </div>
          <p className="text-muted">
            Create and manage class schedules for your club. Set days, times, and class details to keep everything organized.
          </p>
          <button onClick={() => navi("/timetable")} className="btn btn-outline-secondary btn-sm">Find out more</button>
        </div>
      </div>
    </div>

    <div className="col-md-6 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <CreditCard size={28} className="text-primary me-3" />
            <h5 className="mb-0">Create Payment Methods</h5>
          </div>
          <p className="text-muted">
            Set up payment options including subscriptions and pay-as-you-go. Let members pay in the way that works best for them.
          </p>
          {/* <button onClick={() => navi("/receivePayments")} className="btn btn-outline-secondary btn-sm">Find out more</button> */}
        </div>
      </div>
    </div>

    <div className="col-md-6 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <Megaphone size={28} className="text-primary me-3" />
            <h5 className="mb-0">Engage with Members</h5>
          </div>
          <p className="text-muted">
            Send announcements, run promotions, and manage communication directly through your dashboard.
          </p>
          {/* <button className="btn btn-outline-secondary btn-sm">Find out more</button> */}
        </div>
      </div>
    </div>

    <div className="col-md-6 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <BarChart size={28} className="text-primary me-3" />
            <h5 className="mb-0">Analytics and Insights</h5>
          </div>
          <p className="text-muted">
            Monitor attendance, revenue, and member engagement with built-in analytics tools.
          </p>
          {/* <button className="btn btn-outline-secondary btn-sm">Find out more</button> */}
        </div>
      </div>
    </div>

  </div>
)}

    </div>
  )
}
